import type { AnalysisDeath } from "./Analysis";

export type KillerDeaths = {
  // Вражеский герой; `null` — крипы, башни, босс.
  heroId: number | null;
  deaths: AnalysisDeath[];
};

// Смерти игрока по убийцам: больше смертей — выше, при равенстве — кто убил раньше.
// Смерти не от героя — одной группой в конце.
export const groupDeathsByKiller = (deaths: readonly AnalysisDeath[]): KillerDeaths[] => {
  const groups = new Map<number | null, AnalysisDeath[]>();
  for (const death of deaths) {
    groups.set(death.killer_hero_id, [...(groups.get(death.killer_hero_id) ?? []), death]);
  }
  return [...groups.entries()]
    .map(([heroId, list]) => ({ heroId, deaths: list }))
    .sort(
      (a, b) =>
        Number(a.heroId === null) - Number(b.heroId === null) ||
        b.deaths.length - a.deaths.length ||
        (a.deaths[0]?.at_s ?? 0) - (b.deaths[0]?.at_s ?? 0),
    );
};
